import { colors } from '../colors';
export var asurionTheme = {
    primary: colors.primaryDeep,
    primaryHover: colors.primaryBright,
    primaryPressed: colors.primaryDeeper,
    textOnPrimary: colors.white,
    secondary: colors.black,
    secondaryHover: colors.neutralDeepest,
    secondaryPressed: colors.black,
    textOnSecondary: colors.white
};
var partnerTheme = {
    primary: colors.black,
    primaryHover: colors.neutralDeepest,
    primaryPressed: colors.black,
    textOnPrimary: colors.white,
    secondary: colors.black,
    secondaryHover: colors.neutralDeepest,
    secondaryPressed: colors.black,
    textOnSecondary: colors.white
};
export function getTheme(themeKey) {
    if (themeKey === 'asurion') {
        return asurionTheme;
    }
    return partnerTheme;
}
